<template>
  <section>
    <div class="d-flex justify-content-between p-3 mb-2 bg-success text-white">
      <div>
        <h3 class="d-inline m-2">🅱️!BukaPasar</h3>
      </div>
      <div>
        <button @click="toHome" class="btn bg-success font-weight-bold text-white">Add Cart</button>
      </div>
    </div>
    <div>
      <h1 class="m-5">List Cart</h1>
    </div>
    <div class="card mb-3 mx-auto" style="max-width: 540px;">
      <ListCart v-for="cart in carts" :key="cart.id" :cart="cart" />
    </div>
  </section>
</template>

<script>
import ListCart from '../components/ListCart'
export default {
    name: 'Carts',
    computed: {
      carts () {
        return this.$store.state.carts
      }
    },
    created () {
      this.$store.dispatch('fetchCarts')
    },
    components: {
      ListCart
    },
    methods: {
      toHome () {
        this.$router.push('/')
      }
    }
}
</script>

<style>

</style>